export default __webpack_public_path__ + "static/pfsense-6a81268ea0cfd513a1b6f008d0ea3a4f.jpg";